import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
const config = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId
};

export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;
  const userRef = firestore.doc(`users/${userAuth.uid}`);
  const snapShot = await userRef.get();
  if (!snapShot.exists) {
    const { email } = userAuth;
    const createdAt = new Date();
    try {
      await userRef.set({
        email,
        createdAt,
        ...additionalData,
      });
    } catch (error) {
      console.log("Error creating user", error);
    }
  }
  return userRef;
};

firebase.initializeApp(config);
export const auth = firebase.auth();
export const firestore = firebase.firestore();
const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => auth.signInWithPopup(provider);
export const resetPassword = async (email, actionCodeSettings) => {
  try {
    await auth.sendPasswordResetEmail(email, actionCodeSettings);
    return { ok: true };
  } catch (error) {
    console.error("resetPassword error", error);
    return { ok: false, error };
  }
};

export const storage = firebase.storage();

export const uploadAvatar = async (uid, file) => {
  if (!uid || !file) throw new Error('Missing uid or file');
  const ext = file.name.split('.').pop();
  const ref = storage.ref().child(`avatars/${uid}/avatar.${ext}`);
  await ref.put(file);
  const url = await ref.getDownloadURL();
  return url;
};

export const updateUserProfile = async (updates = {}) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error('No authenticated user');
    // update Firebase Auth profile
    await user.updateProfile(updates);
    // mirror important fields to Firestore users doc
    const payload = {};
    if (updates.displayName) payload.displayName = updates.displayName;
    if (updates.photoURL) payload.photoURL = updates.photoURL;
    if (Object.keys(payload).length) {
      const userRef = firestore.doc(`users/${user.uid}`);
      await userRef.set(payload, { merge: true });
    }
    return { ok: true };
  } catch (error) {
    console.error('updateUserProfile error', error);
    return { ok: false, error };
  }
};

export const sendVerificationEmail = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error('No authenticated user');
    await user.sendEmailVerification();
    return { ok: true };
  } catch (error) {
    console.error('sendVerificationEmail error', error);
    return { ok: false, error };
  }
};
export default firebase;
